(() => {
  const FORM_SELECTOR = '[data-search-drawer-form], #predictive-search-form';
  const INPUT_SELECTOR = '[data-search-drawer-input], #search-drawer-input';
  const CLEAR_BUTTON_SELECTOR = '[data-search-drawer-clear]';

  function syncClearButton(form) {
    if (!form) {
      return;
    }

    const input = form.querySelector(INPUT_SELECTOR);
    const clearButton = form.querySelector(CLEAR_BUTTON_SELECTOR);
    if (!input || !clearButton) {
      return;
    }

    const hasQuery = input.value.trim().length > 0;
    clearButton.toggleAttribute('hidden', !hasQuery);
  }

  function handleInput(event) {
    const target = event.target;
    if (!(target instanceof Element) || !target.matches(INPUT_SELECTOR)) {
      return;
    }

    syncClearButton(target.closest(FORM_SELECTOR));
  }

  function handleReset(event) {
    const target = event.target;
    if (!(target instanceof Element) || !target.matches(FORM_SELECTOR)) {
      return;
    }

    requestAnimationFrame(() => {
      syncClearButton(target);
    });
  }

  document.addEventListener('input', handleInput);
  document.addEventListener('reset', handleReset);

  document.querySelectorAll(FORM_SELECTOR).forEach(syncClearButton);
})();
